import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los estados
export const getEstados = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estados`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener estados",
    };
  }
};

// ✅ GET: Traer una estado por ID
export const getEstadoById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estados/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener estado",
    };
  }
};

// ✅ POST: Crear nuevo estado
export const postEstado = async (estadoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estados`;

  try {
    const resp = await axios.post(url, estadoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear estado",
    };
  }
};

// ✅ PUT: Actualizar estado
export const putEstado = async (id, estadoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estados/${id}`;

  try {
    const resp = await axios.put(url, estadoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar estado",
    };
  }
};

// ✅ DELETE: Desactivar estado
export const deleteEstado = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estados/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar estado",
    };
  }
};
